"use client";
import dynamic from "next/dynamic";
import { toasterConfig } from "@client/utils/toast.config";

const Toaster = dynamic(() => import("react-hot-toast").then((m) => m.Toaster), {
  ssr: false
});

export default function ClientToaster() {
  return <Toaster {...toasterConfig} />;
}
